import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BildirishItem from "../../../components/BildirishItem";
import { getContent } from "../../../utils/main";
import axios from "axios";
import MainNoticesPlaceholder from "./placeholders/MainNoticesPlaceholder";

const Bildirishler = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isNoticesLoading, setIsNoticesLoading] = useState(true);
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/notices/main/`)
      .then((res) => {
        setNotices(res.data);
      })
      .then(() => {
        setIsNoticesLoading(false);
      });
  }, []);
  return (
    <div className="bildirish-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 page-section-title">
            <h4 className="title">
              {getContent(content, "Announcement", lang)}
            </h4>
            <p className="content">
              {getContent(content, "Announcement content", lang)}
            </p>
          </div>
          <div className="clearfix mb-4"></div>
          {isNoticesLoading === true ? (
            <MainNoticesPlaceholder />
          ) : (
            notices.map((notice) => (
              <BildirishItem notice={notice} key={notice.id} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Bildirishler;
